const copy = {
  header: '10,000+ of our users love our products.',
  body:
    'We only provide great products combined with excellent customer service. See what our satisfied customers are saying about our services.',
};

export default copy;
